import noUiSlider from 'nouislider';
import { postcodes } from '../../../postcodes';

export default {
  init() {
    // JavaScript to be fired on all pages

    //Pre select some fields on the checkoutpage
    $( 'input[name="customer_type"][value="private"]' ).prop('checked',true);
    $( 'input[name="delivery_time"][value="08.00 - 17.00"]' ).prop('checked',true);

    var coupon = $('.woocommerce-form-coupon-toggle');
    var width = $( window ).width();
    console.log(width);
    if(width < 991) {
      coupon.insertAfter('.checkout.woocommerce-checkout .checkout-block.step-1 .checkout-inner .woocommerce-shipping-fields');
    } else {
      coupon.css('padding', '16px');
      coupon.insertAfter('.shop_table.woocommerce-checkout-review-order-table');
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    let oldValueString = '';
    let newValue = '';
    //shipping is shown without tax. this fixes that. total calculation is correct though
    if ($('h4.mb-0:contains("Leverans")').next().children().first().children().first().length) {
      oldValueString =  $('h4.mb-0:contains("Leverans")').next().children().first().children().first().contents().get(0).nodeValue;
      newValue = parseFloat(oldValueString) * 1.25;
      $('h4.mb-0:contains("Leverans")').next().children().first().children().first().text(newValue.toString() + ' kr');
    }

    if ($('span:contains("Leverans")').next().children().first().children().first().length) {
      oldValueString =  $('span:contains("Leverans")').next().children().first().children().first().contents().get(0).nodeValue;
      newValue = parseFloat(oldValueString) * 1.25;
      $('span:contains("Leverans")').next().children().first().children().first().text(newValue.toString() + ' kr');
    }
    


    $( document.body ).on( 'updated_checkout', function(){

      //shipping is shown without tax. this fixes that. total calculation is correct though
      if ($('span:contains("Leverans")').next().children().first().children().first().length) {
        if ($('span:contains("Leverans")').next().children().first().children().first().contents().get(0).nodeValue.replace(' kr', '') != newValue) {
          oldValueString =  $('span:contains("Leverans")').next().children().first().children().first().contents().get(0).nodeValue;
          newValue = parseFloat(oldValueString) * 1.25;
          $('span:contains("Leverans")').next().children().first().children().first().text(newValue.toString() + ' kr');
        }
      }

      if($('.error-shipping').is(':visible')){
        $('.shipping-wrapper').hide();
        $('#checkout-2').addClass('disabled');
      } else {
        $('.shipping-wrapper').show();
        $('#checkout-2').removeClass('disabled');
      }

      // Change shipping text if uncalculated
      $('.cart-item div span').each(function(){
        if ($(this).text().trim() == 'Frakt tillkommer') {
          $(this).text('Frakt tillkommer 99kr');
        }
      });

    });

    $('.question').on('click', function() {
      $(this).toggleClass('active');
      $(this).children('div').children('span.material-icons-outlined').toggleClass('d-none');
    });

    $('#mobileMenuButton').on('click', function() {
      $('body').toggleClass('no-scroll');
      $('#mobileMenu').toggleClass('open');
    });

    $('#mobileMenuButton').on('click', function(){
      $('#nav-icon').toggleClass('open');
    });
    
    // To open the postcode checker popup in the navbar
    $('#navOpenPostcodeButton').on('click', function() {
      if ($('.postcode-check__popout').hasClass('hidden')) {
        $('.postcode-check__popout').removeClass('hidden');
        // $(this).children('span').html('close');
        $(this).addClass('opaque');
      } 
    });
    
    // To close the postcode checker popup in the navbar
    $('#navClosePostcodeButton').on('click', function() {
      if (!$('.postcode-check__popout').hasClass('hidden')) {
        $('.postcode-check__popout').addClass('hidden');
        // $(this).children('span').html('close');
        $('#navOpenPostcodeButton').removeClass('opaque')
      } 
    });
    
    $('body').on('keydown', function(event) {
      if (event.code == 'Escape') {
        $('.postcode-check__popout').addClass('hidden');
        // $('#navOpenPostcodeButton').children('span').html('travel_explore');
        $('#navOpenPostcodeButton').removeClass('opaque');
      }
    })
    // Functionality for the postcode checker in the navbar
    $('#popup-postcode-btn').on('click', function() {
      const value = $('#navPostcodeInput').val();
      
      // If input is empty do an early return
      if (!value || value == '') return;

      const modifiedValue = value.replaceAll(' ', '').replaceAll('-', '');
      const regex = new RegExp('^[0-9]{5}$')
      const test = regex.test(modifiedValue); 

      if (test) {
        if (postcodes.includes(modifiedValue)) {
          $('#postcodeValidation').html('<p class="color-darkgreen"><b>Vi kan leverera till dig!</b></p>')
        } else {
          $('#postcodeValidation').html('<p class="color-red"><b>Vi kan <u>tyvärr inte</u> leverera till dig ännu</b></p>')
        }
      } else {
          $('#postcodeValidation').html('<p><b>Kontrollera postnummret</b></p>')
      }
    });

    $('div.woocommerce').on('change', '.qty', function(){
      $('[name="update_cart"]').prop('disabled', false);
      $('[name="update_cart"]').trigger('click'); 
    });

    let billingCompanyValue = $('#billing_company').val();
    let billingCompanyNumberValue = $('#organisationsnummer').val();
    $('#billing_company').val('');
    $('#organisationsnummer').val('-');
    // Show or hide content on the checkout page when checking fields
    $('input:radio[name="customer_type"]').change(
      function(){
          if ($(this).is(':checked') && $(this).val() == 'company') {
            $('#billing_company').val(billingCompanyValue);
            $('#organisationsnummer').val(billingCompanyNumberValue);
            $('#billing_company_field').show();
            $('#organisationsnummer_field').show();
          } else {
            billingCompanyValue = $('#billing_company').val();
            billingCompanyNumberValue = $('#organisationsnummer').val();
            $('#billing_company').val('');
            $('#organisationsnummer').val('-');
            $('#billing_company_field').hide();
            $('#organisationsnummer_field').hide();
          }
      }
    );
    
    $('input:checkbox[name="ship_to_different_address"]').change(
      function(){
          if ($(this).is(':checked')) {
            $(this).parent('label').addClass('checked');
          } else {
            $(this).parent('label').removeClass('checked');
          }
      }
    );

    $('input:checkbox[name="want_recycling"]').change(
      function(){
          const other = $('input:checkbox[name="other_pickup"]');
          if ($(this).is(':checked')) {
            $(this).parent('label').addClass('checked');
            $('#want-recycling-fields').show();

            $(other).prop('checked', true);
            $(other).parent('label').addClass('checked');
            $('#recycling-address').hide();
          } else {
            $(this).parent('label').removeClass('checked');
            $('#want-recycling-fields').hide();

            $(other).prop('checked', false);
            $(other).parent('label').removeClass('checked');
            $('#recycling-address').show();
          }
      }
    );

    $('input:checkbox[name="other_pickup"]').change(
      function(){
          if ($(this).is(':checked')) {
            $(this).parent('label').addClass('checked');
            $('#recycling-address').hide();
          } else {
            $(this).parent('label').removeClass('checked');
            $('#recycling-address').show();
          }
      }
    );

    // Change delivery date on thank you page
    $('#changeDelivery').on('click', function() {
      $(this).toggleClass('disabled');
      $('.delivery-date div').toggleClass('d-flex d-none');
    });

    // Checkout form steps
    $('#checkout-1').on('click', function() {
      $('.step-2').removeClass('disabled');

      $(this).removeClass('d-inline-flex');
      $(this).hide();

      $([document.documentElement, document.body]).animate({
        scrollTop: $('.step-2').offset().top-110,
      }, 1500);

      if($('.error-shipping').is(':visible')){
        $('.shipping-wrapper').hide();
        $('#checkout-2').addClass('disabled');
      } else {
        $('.shipping-wrapper').show();
        $('#checkout-2').removeClass('disabled');
      }
    });

    $('#checkout-2').on('click', function() {
      $('.step-3').removeClass('disabled');

      $(this).removeClass('d-inline-flex');
      $(this).hide();

      $([document.documentElement, document.body]).animate({
        scrollTop: $('.step-3').offset().top-110,
      }, 1500);
    });

    $('#checkout-3').on('click', function() {
      $('.step-4').removeClass('disabled');

      $(this).removeClass('d-inline-flex');
      $(this).hide();

      $([document.documentElement, document.body]).animate({
        scrollTop: $('.step-4').offset().top-110,
      }, 1500);
    });

    // Checkout-form on scroll, make review order sticky
    $(window).scroll(function(){
      if($(window).scrollTop() > 210) {
        $('#reviewOrder').addClass('sticky');
      } else {
        $('#reviewOrder').removeClass('sticky');
      }
    });

    // Readmore button on campaign page
    $('#readMore').on('click', function() {
      $('.second-row').toggleClass('open');
      $(this).children().toggleClass('d-none');
    });

    $('#campaignQuestions').on('click', function() {
      $('.question-container .row').toggleClass('open');
      $(this).children().toggleClass('d-none');
    });

    // Format thousand separator
    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    if($('body').hasClass('page-template-template-campaign')) {
      // First slider
      const slider = document.getElementById('slider1');
      noUiSlider.create(slider, {
        start: 60500,
        connect: [true, false],
        step: 500,
        range: {
          'min': 5000,
          'max': 100000,
        },
      });

      // First slider on update
      slider.noUiSlider.on('update', (values, handle) => {
        const sliderAmount = parseInt(values[handle], 10);
        const formatAmount = numberWithCommas(sliderAmount);

        //Set correct texts
        const sliderValue1 = $('#sliderValue1');
        const sliderAmount1 = $('#sliderAmount1');
        sliderValue1.text(`${formatAmount} kr`);
        sliderAmount1.text(`${formatAmount} kr`); 

        //Get persons from other slider
        const getPersons = $('#sliderAmount2').text();
        const personsAmount = parseInt(getPersons);

        //Calculate price
        const getPrice = sliderAmount / personsAmount;
        const calcPrice = getPrice / 110;
        const price = calcPrice.toFixed();

        //Set price
        const div3 = $('#sliderValue3');
        div3.text(`${price} granar var`); 
      });

      // Second slider
      const slider2 = document.getElementById('slider2');
      noUiSlider.create(slider2, {
        start: 20,
        connect: [true, false],
        range: {
          'min': 5,
          'max': 100,
        },
      });

      // Second slider on update
      slider2.noUiSlider.on('update', (values, handle) => {
        const sliderAmount = parseInt(values[handle], 10);
        const formatAmount = numberWithCommas(sliderAmount);

        //Set correct texts
        const sliderValue2 = $('#sliderValue2');
        const sliderAmount2 = $('#sliderAmount2');
        sliderValue2.text(`${formatAmount} pers`);
        sliderAmount2.text(`${formatAmount}`); 

        //Get amount from other slide
        const getAmount = $('#sliderAmount1').text();
        const splitAmount = getAmount.split('kr')[0];
        const amountString = splitAmount.replace(/\s/g, '');
        const amount = parseInt(amountString);

        //Calculate price
        const getPrice = amount / sliderAmount;
        const calcPrice = getPrice / 110;
        const price = calcPrice.toFixed();

        //Set price
        const div3 = $('#sliderValue3');
        div3.text(`${price} granar var`); 
      });
    }

    if($('body').hasClass('home')) {
      var playButton = document.getElementById('play_button');
      var video = document.getElementById('video');
      // Event listener for the play/pause button
      playButton.addEventListener('click', function() {
        if (video.paused == true) {
          // Play the video
          video.play();
          video.setAttribute('controls','controls')
          $('#play_button').hide();
        }
      })
    }

    //change default variant
    console.log('beforeja123');
    if($('body').hasClass('kontorsgran')) {
      console.log('ja123');
    }

    // Functionality for the postcode checker in the navbar
    $('#zipcode-check-button').on('click', function() {
      const value = $('#zipcode-input').val();
      
      // If input is empty do an early return
      if (!value || value == '') return;

      const modifiedValue = value.replaceAll(' ', '').replaceAll('-', '');
      const regex = new RegExp('^[0-9]{5}$')
      const test = regex.test(modifiedValue); 

      if (test) {
        if (postcodes.includes(modifiedValue)) {
          $('.validation-message').html('<span class="color-darkgreen"><b>Vi kan leverera till dig!</b></span>')
        } else {
          $('.validation-message').html('<span class="color-red"><b>Vi kan <u>tyvärr inte</u> leverera till dig ännu</b></span>')
        }
      } else {
          $('.validation-message').html('<span><b>Kontrollera postnummret</b></span>')
      }
    });

    // Change shipping text if uncalculated
    $('.cart-item h4').each(function(){
      if ($(this).text().trim() == 'Frakt tillkommer') {
        $(this).text('Frakt tillkommer 99kr');
      }
    });


      
      



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js